import React from 'react'
import { Helmet } from 'react-helmet'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { WithStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import { State } from '../../application/Store'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { Button, VerifiedIcon } from '@syncfab/machine'
import { Paper } from '@mui/material'
import { withStyles } from '@mui/styles'
import { CenteredContainer } from '../../layout/Container'
import { USER_EMAIL_VALIDATE } from '../../components/user/Actions'

const styles = theme => ({
    paper: {
        padding: theme.spacing(6),
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        alignItems: 'center',
        width: 400,
        'text-align': 'center',
    },
    error: {
        color: theme.palette.error.main,
        marginBottom: theme.spacing(2),
    },
    text: {
        padding: theme.spacing(2),
        color: theme.palette.common.white,
        marginBottom: theme.spacing(2),
    },
    link: {
        textDecoration: 'none',
        width: '100%',
    },
    verifiedIcon: {
        marginLeft: -16,
    },
})

interface UserEmailValidationProps extends WithNamespaces, WithStyles<typeof styles> {
    update: (token: string) => void
    updateEmailValidationError?: string
    updated?: boolean
}

class UserEmailValidationView extends React.Component<UserEmailValidationProps> {
    constructor(props: UserEmailValidationProps) {
        super(props)
        const token = new URLSearchParams(window.location.search.slice(1)).get('token') || ''
        this.props.update(token)
    }

    public render() {
        const { classes, t, updated, updateEmailValidationError } = this.props
        if (!updated && !updateEmailValidationError) {
            return null
        }

        return (
            <CenteredContainer>
                <Helmet>
                    <title>{`${t('user-email-updated-title')}`}</title>
                </Helmet>
                <Paper className={classes.paper} elevation={1}>
                    {updated && !!updateEmailValidationError && (
                        <Typography className={classes.error} variant="caption">
                            {`${t('user-email-updated-error')}`}
                        </Typography>
                    )}
                    {updated && !updateEmailValidationError && (
                        <React.Fragment>
                            <VerifiedIcon className={classes.verifiedIcon} />
                            <Typography className={classes.text} variant="h5">
                                {`${t('user-email-updated-updated')}`}
                            </Typography>
                            <Link to="/login" className={classes.link}>
                                <Button color="primary" fullWidth>
                                    {t('user-email-updated-login')}
                                </Button>
                            </Link>
                        </React.Fragment>
                    )}
                </Paper>
            </CenteredContainer>
        )
    }
}

const mapStateToProps = ({ user: { updateEmailValidationError, updated } }: State) => {
    return {
        updateEmailValidationError,
        updated,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        update: (token: string) => dispatch(USER_EMAIL_VALIDATE.actions.TRIGGER({ token })),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(withStyles(styles)(UserEmailValidationView)))
